import React from "react";
import { Card } from "react-bootstrap";
import "./softwareDevelopment.scss";

const SoftwareDevelopmentContent = () => {
  const industryCardContent = [
    {
      title: "HealthCare ",
      service:
        "(Order and Manufacturing Automation for a multinational pharmaceutical company with 15b revenue)",
    },
    {
      title: "Telecommunication",
      service: "",
    },

    {
      title: "Banking and Finance ",
      service: "(Mobile Payment solution for 6m e-wallets)",
    },

    {
      title: "Retail ",
      service:
        "(white-label system applied in global retail chains as well as a trade marketing planning system for corporation with 82,000 employees)",
    },
  ];

  const tehnologyCardContent = [
    {
      title: "Backend and desktop:",
      service: ".NET, Java, PHP, Node.js, C++",
    },
    {
      title: "Mobile:",
      service: "iOS, Android, Windows Phone, Apache Cordova, Xamarin",
    },

    {
      title: "Frontend:",
      service: "HTML5, CSS3, JS",
    },

    {
      title: "Databases:",
      service:
        "Microsoft SQL Server, MySQL, Oracle, SQL Azure, PostgreSQL, MongoDB",
    },
  ];

  return (
    <div className="tehnology-content-container">

      <div className="dev-content-text-container">
        <p className="content-title">Business Software tailored to your needs</p>
        <p className="dev-content-text">Cube Global offers the development of powerful, one-of-a-kind software intended to meet customers’ unique demands. Our skilled specialists know the game of business and deliver successful solutions that accord with all the specified requirements while invariably staying within time and budget limits. Along with full-cycle custom software development, we provide software maintenance and platform-based customisation.</p>
      </div>

      <div className="dev-content-text-container">
        <p className="content-title">Industry Profile</p>
        <p className="dev-content-text">Throughout years of collaboration with various industries, Cube Global has been able to create a deep insight into their peculiar nature and now grants a highly-professional individual approach. We present solutions that satisfy customers’ needs much more precisely than any off-the-shelf product. Having already finished multiple enterprise software projects and ensured business automation for hundreds of clients, we are experts in:</p>
      </div>

      <div className="tehnology-cards-container">
        <div className="cards">
          {industryCardContent.map((card, index) => (
            <Card key={index} className="card">
              <Card.Body
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  padding: "29px",
                }}
                className="card-content"
              >
                <Card.Text>
                  {" "}
                  <strong className="card-title">{card.title}</strong>{" "}
                  {card.service}
                </Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>

      <div className="dev-content-text-container">
        <p className="content-title">Development Process</p>
        <p className="dev-content-text">With a serious and regardful attitude towards your business, we start from the point of concept examination: our specialists carefully analyse your needs and help you create a detailed software requirements specification, which is indispensable for implementing the project the way you envision it. We offer two most common and effective development methodologies: waterfall and agile. effective development methodologies: waterfall and agile. While with waterfall you decide all the requirements for your project at the very start and get exactly what you need for a set price at a set time, with agile you are in charge during the whole development process and are welcome to add/change requirements and assess the already implemented functionality on the go.Apart from development, Cube Global offers deployment and further maintenance of the existing software.</p>
      </div>

      <div className="dev-content-text-container">
        <p className="content-title">Quality</p>
        <p className="dev-content-text">Among Cube Globals’ specialists, there are only officially certified experts and talented developers with years of experience and technology + industry knowledge. Prioritising competence over speed, they always deliver the product in budget and on schedule. Cube Global’s developers – over 50% of whom are Seniors and Leads – present top-grade software with an architecture that guarantees a solid foundation for further expansion and maintenance, a great user interface and no performance issues.</p>
      </div>

      <div className="dev-content-text-container">
        <p className="content-title">TECHNOLOGIES</p>
        <p className="dev-content-text">We master all levels of software complexity and provide quality solutions on the following technologies:</p>
      </div>

      <div className="tehnology-cards-container">
        <div className="cards">
          {tehnologyCardContent.map((card, index) => (
            <Card key={index} className="card">
              <Card.Body
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  padding: "29px",
                }}
                className="card-content"
              >
                <Card.Text>
                  {" "}
                  <strong className="card-title">{card.title}</strong>{" "}
                  {card.service}
                </Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>

      <div className="dev-content-text-container">
        <p className="content-title">Integration</p>
        <p className="dev-content-text">Software integration can sometimes appear a very lingering process, but we acknowledge its importance and are completely prepared for challenges. Cube Globals’ experts ensure seamless integration of the software with your ERP, CRM, ECM or other business systems.</p>
      </div>

    </div>
  );
};

export default SoftwareDevelopmentContent;
